import React, { ReactElement } from 'react';
import { IconProps } from '../../../../types';

const UserProfilesIcon = ({ className = 'w-6 h-6' }: IconProps): ReactElement => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={2}
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M16.0258 20.5707L16.0261 17.3569C16.0263 15.5818 14.5872 14.1426 12.812 14.1426H5.61481C3.83987 14.1426 2.40095 15.5814 2.40075 17.3563L2.40039 20.5707M21.6001 20.5709L21.6004 17.3571C21.6005 15.5819 20.1615 14.1428 18.3863 14.1428M15.4067 4.06048C16.196 4.64612 16.7075 5.58498 16.7075 6.64331C16.7075 7.70164 16.196 8.64049 15.4067 9.22613M12.4942 6.64313C12.4942 8.41821 11.0552 9.85719 9.28013 9.85719C7.50506 9.85719 6.06608 8.41821 6.06608 6.64313C6.06608 4.86806 7.50506 3.42908 9.28013 3.42908C11.0552 3.42908 12.4942 4.86806 12.4942 6.64313Z"
    />
  </svg>
);

export default UserProfilesIcon;
